import { PseudoElementSelector } from "./pseudo-element.js";
/**
 * {@link https://drafts.csswg.org/css-pseudo-4/#selectordef-selection}
 */
export class Selection extends PseudoElementSelector {
    static of() {
        return new Selection();
    }
    constructor() {
        super("selection");
    }
    *[Symbol.iterator]() {
        yield this;
    }
}
(function (Selection) {
    Selection.parse = PseudoElementSelector.parseNonLegacy("selection", Selection.of);
})(Selection || (Selection = {}));
//# sourceMappingURL=selection.js.map